import React, { useState, useEffect } from 'react';

export default function UpdateStatusModal({ isOpen, onClose, data, onUpdate, isUpdating }) {
  const [remark, setRemark] = useState('');

  useEffect(() => {
    if (isOpen) {
      setRemark('');
    }
  }, [isOpen, data]);

  if (!isOpen) return null;

  const getStatusLabel = (status) => {
    switch (Number(status)) {
      case 0:
        return '⏳ Pending';
      case 1:
        return '🔄 In Progress';
      case 3:
        return '🔓 Re-Opened';
      case 2:
        return '✅ Completed';
      default:
        return 'Unknown Status';
    }
  };

  const newStatusLabel = getStatusLabel(data.newStatus);

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[300] p-4 backdrop-blur-sm">
      <div className="bg-white rounded-2xl p-6 max-w-md w-full shadow-2xl animate-in fade-in zoom-in duration-200">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-xl font-bold text-slate-800">Update Service Status</h3>
          <button 
            onClick={onClose} 
            className="text-slate-400 hover:text-slate-600 transition-colors"
            disabled={isUpdating}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
        
        <div className="space-y-5">
          <div>
            <label className="block text-sm font-semibold text-slate-700 mb-2">Status</label>
            <div className="relative">
              <div className="w-full px-4 py-2.5 border border-amber-200 rounded-xl bg-amber-50 text-sm text-amber-700 font-medium">
                {newStatusLabel}
              </div>
            </div>
          </div>
          
          <div>
            <label className="block text-sm font-semibold text-slate-700 mb-2">
              Remark
              <span className="text-xs font-normal text-slate-500 ml-2">(Required)</span>
            </label>
            <textarea 
              value={remark}
              onChange={(e) => setRemark(e.target.value)}
              placeholder="Please provide details about the status update..."
              disabled={isUpdating}
              className="w-full px-4 py-3 border border-zinc-200 rounded-xl focus:ring-2 focus:ring-amber-500/20 focus:border-amber-500 outline-none h-32 resize-none text-sm placeholder:text-slate-400 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
              required
            />
            {!remark.trim() && (
              <p className="text-xs text-amber-600 mt-1">
                ⚠️ Remark is required to update status
              </p>
            )}
          </div>
        </div>

        <div className="flex gap-3 justify-end mt-8">
          <button
            onClick={onClose}
            disabled={isUpdating}
            className="px-5 py-2.5 text-sm font-semibold bg-black text-white rounded-lg hover:bg-gray-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Cancel
          </button>
          <button
            onClick={() => {
              if (remark.trim()) {
                onUpdate(data.rcid, data.newStatus, remark);
              }
            }}
            disabled={isUpdating || !remark.trim()}
            className={`px-8 py-2.5 text-sm font-bold bg-gradient-to-r from-amber-500 to-orange-500 text-white rounded-lg transition-all ${
              isUpdating || !remark.trim()
                ? 'opacity-50 cursor-not-allowed' 
                : 'hover:from-amber-600 hover:to-orange-600'
            }`}
          >
            {isUpdating ? (
              <div className="flex items-center gap-2">
                <div className="h-4 w-4 animate-spin rounded-full border-2 border-solid border-white border-r-transparent"></div>
                <span>Updating...</span>
              </div>
            ) : (
              'Update Status'
            )}
          </button>
        </div>
      </div>
    </div>
  );
}